import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import ViewMore from '../../../components/ViewMore';
import Faq from '../../../components/Faq';
import Why from '../../../components/Why';
import ProcessSlider from '../../../components/sliders/ProcessSlider';
import SolveProblemsWhiteboard from '../../../components/video-production/explainer-videos/SolveProblemsWhiteboard';
import BenefitsWhiteboard from '../../../components/video-production/explainer-videos/BenefitsWhiteboard';

import typesLottie from '../../../public/images/types.json';

lazyload({
  width: '100%',
});

const ExplainerVideosWhiteboard = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Whiteboard Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/whiteboard-explainer-video" />
        <meta
          name="description"
          content="Improve your brand's storytelling with Prodigi's whiteboard explainer videos. Simplify complex ideas into engaging visuals that captivate your audience."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/whiteboard-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Whiteboard Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Improve your brand's storytelling with Prodigi's whiteboard explainer videos. Simplify complex ideas into engaging visuals that captivate your audience."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/whiteboard-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Whiteboard Explainer Video",
              "description": "Improve your brand's storytelling with Prodigi's whiteboard explainer videos. Simplify complex ideas into engaging visuals that captivate your audience.",
              "url": "https://weprodigi.com/video-production/whiteboard-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Whiteboard Explainer Video Production",
                    "item": "https://weprodigi.com/video-production/whiteboard-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Whiteboard Explainer Video Production",
                "description": "Improve your brand's storytelling with Prodigi's whiteboard explainer videos. Simplify complex ideas into engaging visuals that captivate your audience.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1200",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Michael Anderson"
                    },
                    "datePublished": "2024-01-19",
                    "reviewBody": "Highly recommend! The whiteboard video created for my business was professional and delivered on time. Great communication throughout."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Olivia Garcia"
                    },
                    "datePublished": "2024-02-27",
                    "reviewBody": "Impressive creativity! The whiteboard animation brought our concept to life in a visually appealing and engaging way. Highly impressed!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Lucas Rivera"
                    },
                    "datePublished": "2024-02-28",
                    "reviewBody": "Highly professional! The whiteboard explainer video effectively communicated our message and was well-received by our target audience."
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/whiteboard-explainer/whiteboard-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Whiteboard Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/whiteboard-explainer-video',
                name: 'Whiteboard Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  Do you want to weave your brand story not only with words but also with striking visuals? A whiteboard explainer video is an ideal
                  choice. Don’t convey your messages and ideas in a complex, boring way. You can showcase everything in just a few minutes with vivid
                  shots. Your audience seeks clarity and creativity—exactly what whiteboard videos provide. Let's unlock the magic behind their power
                  from A to Z!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Whiteboard Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/WNWzdjLjtVw?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Whiteboard Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A whiteboard explainer video is a short, distinctive animation. Eye-catching visuals and details step-by-step spread on a blank
                background. It seems that someone is hand-drawing them all on the whiteboard. This unique process attracts viewers’ attention and
                keeps them fascinated till the end. But this is just the beginning of the party! Whiteboard animations can help you to turn complex
                topics into easy-to-understand, simple, and fun content. They captivate everyone without exception. It's no surprise that many
                businesses use these dynamic tools to educate, inform, and engage their audiences. The top industries among them are marketing,
                education and IT.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A whiteboard explainer video is a short, distinctive animation. Eye-catching visuals and details step-by-step spread on a blank
                  background. It seems that someone is hand-drawing them all on the whiteboard. This unique process attracts viewers’ attention and
                  keeps them fascinated till the end. But this is just the beginning of the party! Whiteboard animations can help you to turn complex
                  topics into easy-to-understand, simple, and fun content. They captivate everyone without exception. It's no surprise that many
                  businesses use these dynamic tools to educate, inform, and engage their audiences. The top industries among them are marketing,
                  education and IT.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where To Use Whiteboard Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              Getting attention in the digital age is a real challenge. The time that a person spends watching 1 video is getting shorter and shorter,
              on average 5-10 seconds. A whiteboard explainer video is your effective weapon in that battle. It interests, engages, educates, and much
              more. Depending on the field, it offers several benefits. Check them out below!
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/ooAyhLlZAc0?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Lane Health | Whiteboard Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Endless benefits! That's what whiteboard explainer videos provide to any business. Use its power to explain a complex topic,
                  product, or service. Top-notch whiteboard explainers are adaptable and versatile. You can use them across various platforms: whether
                  it’s social media, websites, or email campaigns. Their unique visual art, storytelling, and sound hold viewers’ attention and drive
                  actions. Showcase your new product, tell your brand story, share your customer testimonials, and much more. You can be sure your
                  marketing message won't go unnoticed!
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Endless benefits! That's what whiteboard explainer videos provide to any business. Use its power to explain a complex topic,
                    product, or service. Top-notch whiteboard explainers are adaptable and versatile. You can use them across various platforms:
                    whether it’s social media, websites, or email campaigns. Their unique visual art, storytelling, and sound hold viewers’ attention
                    and drive actions. Showcase your new product, tell your brand story, share your customer testimonials, and much more. You can be
                    sure your marketing message won't go unnoticed!
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Today's education system needs more effective, dynamic tools. Whiteboard explainer videos are really useful for this. They help
                  learners to understand and remember even the most complex ideas much better. How do they do it? By turning difficult topics into
                  simple, fun, and easy-to-understand content. Thanks to eye-catching visuals, sound effects, and animated style, these creative
                  videos grab attention and keep viewers engaged. They're also cost-effective and can be used in many ways. That's why they're so
                  popular across schools, universities, language and training centers.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Today's education system needs more effective, dynamic tools. Whiteboard explainer videos are really useful for this. They help
                    learners to understand and remember even the most complex ideas much better. How do they do it? By turning difficult topics into
                    simple, fun, and easy-to-understand content. Thanks to eye-catching visuals, sound effects, and animated style, these creative
                    videos grab attention and keep viewers engaged. They're also cost-effective and can be used in many ways. That's why they're so
                    popular across schools, universities, language and training centers.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/FKFO59ndlVc?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Access Lawyers Group | Whiteboard Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/Gu6GKjHJzLw?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Skye Capital | Whiteboard Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Financial Field</h3>
                <p className={'mt-16 hidden md:block'}>
                  Top-notch whiteboard explainer videos open a new door to success for any financial company. It's shown that a good whiteboard
                  explainer increases the recognition of a finance project several times. Unleash the power of these videos for your financial product
                  promotion․ Show off your product or service in a catchy way, explain its benefits clearly, and teach people how to use it. This
                  approach not only captivates your audience with engaging visuals but also builds trust by demystifying complex financial concepts,
                  making your service or product more accessible and understandable to potential clients.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Top-notch whiteboard explainer videos open a new door to success for any financial company. It's shown that a good whiteboard
                    explainer increases the recognition of a finance project several times. Unleash the power of these videos for your financial
                    product promotion․ Show off your product or service in a catchy way, explain its benefits clearly, and teach people how to use it.
                    This approach not only captivates your audience with engaging visuals but also builds trust by demystifying complex financial
                    concepts, making your service or product more accessible and understandable to potential clients.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Whiteboard Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Turn complex topics into simple and fun content and empower your project with a whiteboard explainer video. It uses striking drawings to
              catch viewers' eyes and help them comprehend the ideas shared. This type of animation is great for education, marketing, and information
              sharing. Let us discover why it’s so helpful and popular in these fields and beyond.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsWhiteboard />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Whiteboard Explainer Video Production Process
            </h2>
            <ProcessSlider />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44  text-20 md:text-25 lg:text-36'
              }
            >
              Calculate Your Whiteboard Explainer Video Price
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Can a Whiteboard Explainer Video Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Vibrant, fun and powerful! Such are whiteboard explainer videos as business tools. They are simple and engaging - just what any brand
              needs to connect more deeply with its customers. Whether you want to explain a topic, tell your story, or introduce a new product, these
              videos do the job well. Let's dive into how they can assist you achieve your business goals.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsWhiteboard />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Whiteboard Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time',
                  answer:
                    'We know how precious your time and management resources are. When we start working together, we quickly get what your business needs and wants. During the whole video production process, from ongoing communication to payment methods, we apply our proven time-saving solutions for your real satisfaction.',
                },
                {
                  title: 'We include digital marketing specialists in the production process',
                  answer:
                    "Creating an eye-catching whiteboard explainer video is cool. But how and where to use it to get maximum results? This question will be answered by our digital marketing specialist who will be involved in the entire process of your video production. With the help of our specialist, we will thoroughly analyze your business needs and prospects to help you find the best online platform for your video, whether it's Facebook, Amazon, YouTube, or your website.",
                },
                {
                  title: 'We don’t require prepayment',
                  answer:
                    "Why pay for work not yet done? We have chosen the option of milestone payments, as we believe that it is the optimal option for both us and our clients. And that's not all! We never charge for a video product that is not approved by you. If you are not satisfied with the results, 100% money-back is guaranteed.",
                },
                {
                  title: 'We provide customized solutions',
                  answer:
                    "Is the mix of aesthetic drawings and stunning audio enough to create an effective whiteboard explainer video? We're certain it's NOT. Only videos tailored to your brand identity, mission, and target audience can touch the pulse of success. A deep study of the essence of your brand allows us to create such videos that perfectly combine aesthetics and content depth. This personalization ensures that your video resonates deeply with viewers and effectively conveys your message.",
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'Is whiteboard animation 2D or 3D?',
                    answer:
                      'Whiteboard animation is primarily 2D. It simulates drawing on a blank whiteboard, using flat, two-dimensional drawings to tell a story, showcase a product, or explain a topic.',
                  },
                  {
                    title: 'Why are whiteboard explainer videos so effective?',
                    answer:
                      'Whiteboard explainer videos are highly effective due to a unique blend of visual simplicity and compelling storytelling. The use of simple, hand-drawn drawings captures viewer interest and engages them deeply. But that’s not all! They not only seize attention but also improve information retention and drive actions.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'Are whiteboard videos effective?',
                    answer:
                      'Whiteboard videos are extremely effective. They simplify complex ideas and engage viewers, boosting understanding and retention.',
                  },
                  {
                    title: 'Are whiteboard explainer videos popular?',
                    answer:
                      'Whiteboard explainer videos are quite popular, especially in the education, marketing, and technology industries. They excel at breaking down complex ideas into engaging, easy-to-understand visuals.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosWhiteboard;
